import { createBrowserHistory } from "history";
import { applyMiddleware, createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import createSagaMiddleware from "redux-saga";
import { rootReducer } from "../store/reducers";
import { sagas } from "../store/sagas";

const history = createBrowserHistory();

const sagaMiddleware = createSagaMiddleware();

export default () => {
  const store = createStore(
    rootReducer,
    composeWithDevTools(applyMiddleware(sagaMiddleware))
  ) as any;
  sagas.forEach((saga) => {
    sagaMiddleware.run(saga);
  });
  return { store };
};

export { history };
